import { stateSync, TSyncProp, AStateManager } from '@ui/frontend-app-manager';
import { GetterTree, Module, Store } from 'vuex';
import { StorePlugin } from '@/store/Store';
import { State } from '@/store/state';

type PropValue = TSyncProp | null | undefined;
type SetPropPayload = {
  id: string;
  value: PropValue;
};
type ModuleState = { [propId: string]: PropValue };

export type StateSyncPlugin = StorePlugin;
export type StateSyncPluginOptions = {
  moduleName?: string;
  defaultState: ModuleState;
};

export function createStateSyncPlugin(options: StateSyncPluginOptions): StateSyncPlugin {
  const defaultModuleName: string = 'stateSync';

  return (store: Store<State>): void => {
    const moduleName: string = options.moduleName || defaultModuleName;
    const propIds: string[] = Object.keys(options.defaultState);
    const module: Module<ModuleState, State> = {
      namespaced: true,
      state: { ...options.defaultState },
      getters: propIds.reduce((result: GetterTree<ModuleState, State>, propId: string) => {
        result[propId] = (state: ModuleState) => state[propId];
        return result;
      }, {}),
      mutations: {
        setProp(state: ModuleState, prop: SetPropPayload) {
          Object.assign(state, { [prop.id]: prop.value });
        }
      }
    };
    const stateManager: AStateManager = stateSync.stateManager();

    store.registerModule(moduleName, module);

    propIds.forEach((propId: string): void => {
      try {
        stateManager.subscribeToPropChanges(propId, (propValue: PropValue): void => {
          store.commit(`${moduleName}/setProp`, {
            id: propId,
            value: propValue
          });
        });
      } catch (error) {
        console.error(error.message);
      }
    });
  };
}
